function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 19c4.823 24.596 10 31 20.15 27.011C32.553 41.529 35.809 3.681 56 13"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 5.6,
  width: 11,
  height: 4,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 3.6,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 3.6,
  r: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-52.149)",
  x: 4.221,
  y: 35.779,
  width: 11,
  height: 4,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-52.149)",
  cx: 9.221,
  cy: 33.779,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-52.149)",
  cx: 13.221,
  cy: 33.779,
  r: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-61.142)",
  x: -17.113,
  y: 36.705,
  width: 11,
  height: 4,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-61.142)",
  cx: -12.113,
  cy: 34.705,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-61.142)",
  cx: -8.113,
  cy: 34.705,
  r: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M5 34.8V54M15 47v7M25 42.8V54M35 25v29M45 13v41M55 13v41"
}));

var SvgRollercoaster = function SvgRollercoaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRollercoaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Roller coaster.c32dbd2e.svg";
export { ForwardRef as ReactComponent };